// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

// SCANNER-ONLY
import { FleetMapAreaId } from '@backoffice-frontend/common'
import i18next from 'i18next'
import de from './de-DE.json'
import en from './en-GB.json'

export const loadTranslations = () => {
  i18next.addResourceBundle('de', FleetMapAreaId, de)
  i18next.addResourceBundle('en', FleetMapAreaId, en)
}
